// import { Icon } from "@iconify/react/dist/iconify.js";
// import { useCallback, useEffect, useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import Cropper from "react-cropper";
// import "cropperjs/dist/cropper.css";
// import LoadingComponent from "./ui/LoadingComponent";
// import TableDataNoAvailable from "./ui/TableDataNoAvailable";
// import PaginationControls from "./ui/PaginationControls";
// import PerPageDropdown from "./ui/PerPageDropdown";
// import { apiCall } from "../Apis/apiCall";
// import { usePermissions } from "../context/PermissionContext";
// import { handleApiResponse, handleCustomResponse } from "../utils/response";
// import SortIcons from "./ui/SortIcons";

// const VehicleMakesLayer = () => {
//   const [vehicleMakes, setVehicleMakes] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modalType, setModalType] = useState(""); // 'add', 'edit', or 'delete'
//   const [showModal, setShowModal] = useState(false);
//   const [vehicleMakeId, setVehicleMakeId] = useState(null);
//   const [makeName, setMakeName] = useState("");
//   const [makeImage, setMakeImage] = useState(null);
//   const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
//   const [imageUploading, setImageUploading] = useState(false);
//   const [selectedVehicleMake, setSelectedVehicleMake] = useState(null);
//   const [perPage, setPerPage] = useState(10);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalEntries, setTotalEntries] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [saveLoading, setSaveLoading] = useState(false);
//   const [sortConfig, setSortConfig] = useState({
//     field: "make_name",
//     direction: "asc",
//   });
//   const [expandedRows, setExpandedRows] = useState({});
//   const [showImageModal, setShowImageModal] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [showCropModal, setShowCropModal] = useState(false);
//   const [imageToCrop, setImageToCrop] = useState(null);
//   const [aspectRatio, setAspectRatio] = useState("1:1");
//   const cropperRef = useRef(null);
//   const navigate = useNavigate();
//   const { hasPermission } = usePermissions();

//   const debounce = (func, delay) => {
//     let timeoutId;
//     return (...args) => {
//       if (timeoutId) clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => {
//         func(...args);
//       }, delay);
//     };
//   };

//   const debouncedSetSearch = useCallback(
//     debounce((query) => setDebouncedSearchQuery(query), 500),
//     []
//   );

//   useEffect(() => {
//     debouncedSetSearch(searchQuery);
//   }, [searchQuery, debouncedSetSearch]);

//   const fetchVehicleMakes = async () => {
//     setLoading(true);
//     try {
//       const params = {
//         search: debouncedSearchQuery,
//         sort_by: sortConfig.field,
//         sort_order: sortConfig.direction,
//         per_page: perPage,
//         page: currentPage,
//       };
//       const response = await apiCall("get", "/get-all-vehicle-makes", params);
//       setVehicleMakes(response.data.data.data);
//       setTotalEntries(response.data.data.total);
//       setTotalPages(
//         response.data.data.last_page ||
//           response.data.data.total_pages ||
//           Math.ceil(response.data.data.total / perPage)
//       );
//       setCurrentPage(response.data.data.current_page);

//       const handleRes = response.data;
//       handleApiResponse(handleRes, "success", "GET");
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "GET");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehicleMakes();
//   }, [debouncedSearchQuery, sortConfig, perPage, currentPage]);

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSort = (field) => {
//     if (field === "created_by") return; // Skip unavailable field
//     setSortConfig((prev) => ({
//       field,
//       direction:
//         prev.field === field && prev.direction === "asc" ? "desc" : "asc",
//     }));
//     setCurrentPage(1);
//   };

//   const handleOpenModal = (type, vehicleMake = null) => {
//     setModalType(type);
//     setShowModal(true);
//     setVehicleMakeId(null);
//     setMakeName("");
//     setMakeImage(null);
//     setUploadedImageUrl(null);
//     setImageUploading(false);
//     setSelectedVehicleMake(null);

//     if (type === "edit" && vehicleMake) {
//       setVehicleMakeId(vehicleMake.make_id);
//       setMakeName(vehicleMake.make_name || "");
//       setUploadedImageUrl(vehicleMake.make_image || null);
//       setSelectedVehicleMake(vehicleMake);
//     } else if (type === "delete" && vehicleMake) {
//       setSelectedVehicleMake(vehicleMake);
//       setVehicleMakeId(vehicleMake.make_id);
//     }
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setModalType("");
//     setVehicleMakeId(null);
//     setMakeName("");
//     setMakeImage(null);
//     setUploadedImageUrl(null);
//     setImageUploading(false);
//     setSelectedVehicleMake(null);
//   };

//   const handleOpenImageModal = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     setShowImageModal(true);
//   };

//   const handleCloseImageModal = () => {
//     setShowImageModal(false);
//     setSelectedImage(null);
//   };

//   const handleImageSelect = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 5 * 1024 * 1024) {
//         handleCustomResponse("error", "Image size should not exceed 5MB.");
//         return;
//       }
//       if (!file.type.startsWith("image/")) {
//         handleCustomResponse("error", "Please select a valid image file.");
//         return;
//       }
//       const reader = new FileReader();
//       reader.onload = () => {
//         setImageToCrop(reader.result);
//         setShowCropModal(true);
//         setAspectRatio("1:1");
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleCrop = async () => {
//     if (cropperRef.current) {
//       const canvas = cropperRef.current.cropper.getCroppedCanvas({
//         width: 200,
//         height: 200,
//       });

//       canvas.toBlob(
//         async (blob) => {
//           if (!blob) {
//             handleCustomResponse("error", "Failed to crop image.");
//             return;
//           }
//           const file = new File([blob], `vehicle-make-${Date.now()}.png`, {
//             type: "image/png",
//           });
//           setMakeImage(file);
//           setShowCropModal(false);
//           await handleImageUpload(file);
//         },
//         "image/png",
//         0.8
//       );
//     } else {
//       handleCustomResponse("error", "Cropper not initialized.");
//     }
//   };

//   const handleImageUpload = async (file) => {
//     if (!file) {
//       handleCustomResponse("error", "No image selected for upload.");
//       return;
//     }

//     try {
//       setImageUploading(true);
//       const formData = new FormData();
//       formData.append("vehicle_make", file);

//       const response = await apiCall(
//         "post",
//         "/upload-image",
//         formData,
//         navigate,
//         true
//       );

//       if (response?.data?.tiny_url) {
//         setUploadedImageUrl(response.data.tiny_url);
//         setMakeImage(file);
//         handleCustomResponse("success", "Image uploaded successfully!");
//       } else {
//         handleCustomResponse("error", "Failed to upload image.");
//         setMakeImage(null);
//       }
//     } catch (error) {
//       handleCustomResponse("error", "Error uploading image.");
//       setMakeImage(null);
//     } finally {
//       setImageUploading(false);
//     }
//   };

//   const handleCloseCropModal = () => {
//     setShowCropModal(false);
//     setImageToCrop(null);
//     setAspectRatio("1:1");
//   };

//   const handleCropMove = () => {
//     if (cropperRef.current) {
//       const cropBoxData = cropperRef.current.cropper.getCropBoxData();
//       const width = cropBoxData.width;
//       const height = cropBoxData.height;
//       const ratio = width / height;
//       setAspectRatio(`${(width / height).toFixed(2)}:1`);
//     }
//   };

//   const handleAddVehicleMake = async () => {
//     if (!makeName.trim()) {
//       handleCustomResponse("error", "Vehicle Make Name is required.");
//       return;
//     }

//     setSaveLoading(true);
//     try {
//       const formData = new FormData();
//       formData.append("make_name", makeName);
//       if (uploadedImageUrl) formData.append("make_image", uploadedImageUrl);

//       const response = await apiCall(
//         "post",
//         "/add-vehicle-make",
//         formData,
//         navigate,
//         true
//       );
//       const handleRes = response.data;
//       handleApiResponse(handleRes, "success", "POST");
//       fetchVehicleMakes();
//       handleCloseModal();
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "POST");
//     } finally {
//       setSaveLoading(false);
//     }
//   };

//   const handleUpdateVehicleMake = async () => {
//     if (!makeName.trim()) {
//       handleCustomResponse("error", "Vehicle Make Name is required.");
//       return;
//     }

//     if (!vehicleMakeId || isNaN(vehicleMakeId)) {
//       handleCustomResponse("error", "Invalid or missing Vehicle Make ID.");
//       return;
//     }

//     setSaveLoading(true);
//     try {
//       const updateData = {
//         make_name: makeName,
//       };

//       if (uploadedImageUrl) {
//         updateData.make_image = uploadedImageUrl;
//       }

//       const res = await apiCall(
//         "put",
//         `/update-vehicle-make/${vehicleMakeId}`,
//         updateData,
//         navigate,
//         false
//       );
//       const handleRes = res.data;
//       handleApiResponse(handleRes, "success", "PUT");
//       fetchVehicleMakes();
//       handleCloseModal();
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "PUT");
//     } finally {
//       setSaveLoading(false);
//     }
//   };

//   const handleDeleteVehicleMake = async () => {
//     if (!vehicleMakeId || isNaN(vehicleMakeId)) {
//       handleCustomResponse("error", "Invalid or missing Vehicle Make ID.");
//       return;
//     }

//     setSaveLoading(true);
//     try {
//       const res = await apiCall(
//         "delete",
//         `/delete-vehicle-make/${vehicleMakeId}`,
//         null,
//         navigate
//       );

//       const handleRes = res.data;
//       handleApiResponse(handleRes, "success", "DELETE");
//       fetchVehicleMakes();
//       handleCloseModal();
//     } catch (error) {
//       const handleErr = error.response?.data;
//       handleApiResponse(handleErr, "Err", "DELETE");
//     } finally {
//       setSaveLoading(false);
//     }
//   };

//   const handleSubmit = () => {
//     if (modalType === "add") {
//       handleAddVehicleMake();
//     } else if (modalType === "edit") {
//       handleUpdateVehicleMake();
//     } else if (modalType === "delete") {
//       handleDeleteVehicleMake();
//     }
//   };

//   const handlePageChange = (page) => {
//     if (page !== currentPage && page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   const truncateText = (text, maxLength = 50) => {
//     if (!text || text.length <= maxLength) return text;
//     return text.substring(0, maxLength) + "...";
//   };

//   const toggleExpand = (makeId, field) => {
//     setExpandedRows((prev) => ({
//       ...prev,
//       [`${makeId}_${field}`]: !prev[`${makeId}_${field}`],
//     }));
//   };

//   const startEntry = totalEntries > 0 ? (currentPage - 1) * perPage + 1 : 0;
//   const endEntry = Math.min(currentPage * perPage, totalEntries);

//   return (
//     <div className="p-4 p-md-3 p-sm-2">
//       <style>
//         {`
//           .table-responsive .table td, .table-responsive .table th {
//             max-width: 200px;
//             vertical-align: middle;
//           }
//           .show-more-btn {
//             color: #E63C23;
//             cursor: pointer;
//             font-size: 12px;
//             margin-left: 5px;
//             background: none;
//             border: none;
//             padding: 0;
//           }
//           .show-more-btn:hover {
//             text-decoration: underline;
//           }
//           .image-preview {
//             cursor: pointer;
//             transition: transform 0.2s;
//           }
//           .image-preview:hover {
//             transform: scale(1.05);
//           }
//           @media (max-width: 576px) {
//             .table-responsive .table td, .table-responsive .table th {
//               max-width: 100px;
//             }
//             .show-more-btn {
//               font-size: 10px;
//             }
//           }
//           .cropper-container {
//             max-height: 400px;
//             max-width: 100%;
//           }
//           .aspect-ratio-display {
//             font-size: 14px;
//             color: #333;
//             margin-top: 10px;
//             text-align: center;
//           }
//         `}
//       </style>
//       <div className="p-4 p-md-3 p-sm-2">
//         <div className="card shadow-sm">
//           <div className="card p-3 p-sm-2 p-md-3">
//             <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
//               <div
//                 className="icon-field flex-grow-1"
//                 style={{ maxWidth: "400px" }}
//               >
//                 <input
//                   type="text"
//                   className="form-control form-control-sm"
//                   placeholder="Search by vehicle make..."
//                   value={searchQuery}
//                   onChange={handleSearchChange}
//                 />
//                 <span className="icon">
//                   <Icon icon="ion:search-outline" />
//                 </span>
//               </div>
//               <PerPageDropdown
//                 perPage={perPage}
//                 handlePerPageChange={(value) => {
//                   setPerPage(value);
//                   setCurrentPage(1);
//                 }}
//               />
//               <div className="ms-auto">
//                 {hasPermission("insert_vehicle_makes") && (
//                   <button
//                     className="btn btn-primary-600 btn-sm d-flex align-items-center"
//                     onClick={() => handleOpenModal("add")}
//                   >
//                     <Icon icon="ri:add-line" className="me-1" /> Add Vehicle
//                     Make
//                   </button>
//                 )}
//               </div>
//             </div>

//             {vehicleMakes.length === 0 && !loading ? (
//               <TableDataNoAvailable message="No vehicle makes found." />
//             ) : (
//               <div className="position-relative">
//                 <div
//                   className="table-responsive"
//                   style={{
//                     opacity: loading ? 0.4 : 1,
//                     pointerEvents: loading ? "none" : "auto",
//                   }}
//                 >
//                   <table className="table bordered-table mb-0 table-hover">
//                     <thead>
//                       <tr
//                         style={{ backgroundColor: "#475EAB", color: "white" }}
//                       >
//                         <th scope="col" className="p-2">
//                           <span>S.No</span>
//                         </th>
//                        <th
//   scope="col"
//   className="p-2"
//   onClick={() => handleSort("make_name")}
//   style={{ cursor: "pointer" }}
// >
//   <div className="d-flex align-items-center justify-content-between">
//     <span>Vehicle Make</span>
//     <SortIcons field="make_name" sortConfig={sortConfig} />
//   </div>
// </th>
//                        <th
//   scope="col"
//   className="p-2"
//   onClick={() => handleSort("created_datetime")}
//   style={{ cursor: "pointer" }}
// >
//   <div className="d-flex align-items-center justify-content-between">
//     <span>Created At</span>
//     <SortIcons field="created_datetime" sortConfig={sortConfig} />
//   </div>
// </th>
//                        <th
//   scope="col"
//   className="p-2"
//   onClick={() => handleSort("make_image")}
//   style={{ cursor: "pointer" }}
// >
//   <div className="d-flex align-items-center justify-content-between">
//     <span>Image</span>
//     <SortIcons field="make_image" sortConfig={sortConfig} />
//   </div>
// </th>
//                        <th
//   scope="col"
//   className="p-2"
//   onClick={() => handleSort("is_active")}
//   style={{ cursor: "pointer" }}
// >
//   <div className="d-flex align-items-center justify-content-between">
//     <span>Status</span>
//     <SortIcons field="is_active" sortConfig={sortConfig} />
//   </div>
// </th>
//                         <th scope="col" className="p-2">
//                           Action
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {vehicleMakes.map((vehicleMake, index) => (
//                         <tr key={vehicleMake.make_id || index}>
//                           <td className="p-2">{startEntry + index}</td>
//                           <td className="p-2">
//                             <span className="text-primary-600">
//                               {expandedRows[`${vehicleMake.make_id}_make_name`]
//                                 ? vehicleMake.make_name || "N/A"
//                                 : truncateText(vehicleMake.make_name || "N/A")}
//                               {vehicleMake.make_name &&
//                                 vehicleMake.make_name.length > 50 && (
//                                   <button
//                                     className="show-more-btn"
//                                     onClick={() =>
//                                       toggleExpand(
//                                         vehicleMake.make_id,
//                                         "make_name"
//                                       )
//                                     }
//                                   >
//                                     {expandedRows[
//                                       `${vehicleMake.make_id}_make_name`
//                                     ]
//                                       ? "Show Less"
//                                       : "Show More"}
//                                   </button>
//                                 )}
//                             </span>
//                           </td>
//                           <td className="p-2">
//                             {new Date(
//                               vehicleMake.created_datetime
//                             ).toLocaleString() || "N/A"}
//                           </td>
//                           <td className="p-2">
//                             {vehicleMake.make_image ? (
//                               <img
//                                 src={vehicleMake.make_image}
//                                 alt={vehicleMake.make_name}
//                                 className="image-preview"
//                                 style={{ maxWidth: "50px", maxHeight: "50px" }}
//                                 onClick={() =>
//                                   handleOpenImageModal(vehicleMake.make_image)
//                                 }
//                               />
//                             ) : (
//                               "N/A"
//                             )}
//                           </td>
//                           <td className="p-2 text-center">
//                             <span
//                               className={`px-3 py-1 radius-4 fw-medium text-sm ${
//                                 vehicleMake.is_active
//                                   ? "bg-success-focus text-success-600 border border-success-main"
//                                   : "bg-danger-focus text-danger-600 border border-danger-main"
//                               }`}
//                             >
//                               {vehicleMake.is_active ? "Active" : "Inactive"}
//                             </span>
//                           </td>
//                           <td className="p-2">
//                             {hasPermission("update_vehicle_makes") && (
//                               <button
//                                 className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
//                                 style={{
//                                   position: "relative",
//                                   transition: "all 0.3s ease",
//                                   cursor: "pointer",
//                                 }}
//                                 onMouseEnter={(e) => {
//                                   e.currentTarget.style.transform =
//                                     "scale(1.1)";
//                                   const tooltip = document.createElement("div");
//                                   tooltip.textContent = "Edit";
//                                   tooltip.style.cssText = `
//                                 position: absolute;
//                                 top: -35px;
//                                 left: 50%;
//                                 transform: translateX(-50%);
//                                 background-color: #333;
//                                 color: white;
//                                 padding: 5px 8px;
//                                 border-radius: 4px;
//                                 font-size: 12px;
//                                 white-space: nowrap;
//                                 z-index: 1000;
//                                 pointer-events: none;
//                               `;
//                                   tooltip.id = "edit-tooltip";
//                                   e.currentTarget.appendChild(tooltip);
//                                 }}
//                                 onMouseLeave={(e) => {
//                                   e.currentTarget.style.transform = "scale(1)";
//                                   const tooltip =
//                                     document.getElementById("edit-tooltip");
//                                   if (tooltip) tooltip.remove();
//                                 }}
//                                 onClick={() =>
//                                   handleOpenModal("edit", vehicleMake)
//                                 }
//                               >
//                                 <Icon icon="lucide:edit" />
//                               </button>
//                             )}
//                             {hasPermission("delete_vehicle_makes") && (
//                               <button
//                                 className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
//                                 style={{
//                                   position: "relative",
//                                   transition: "all 0.3s ease",
//                                   cursor: "pointer",
//                                 }}
//                                 onMouseEnter={(e) => {
//                                   e.currentTarget.style.transform =
//                                     "scale(1.1)";
//                                   const tooltip = document.createElement("div");
//                                   tooltip.textContent = "Delete";
//                                   tooltip.style.cssText = `
//                                 position: absolute;
//                                 top: -35px;
//                                 left: 50%;
//                                 transform: translateX(-50%);
//                                 background-color: #333;
//                                 color: white;
//                                 padding: 5px 8px;
//                                 border-radius: 4px;
//                                 font-size: 12px;
//                                 white-space: nowrap;
//                                 z-index: 1000;
//                                 pointer-events: none;
//                               `;
//                                   tooltip.id = "delete-tooltip";
//                                   e.currentTarget.appendChild(tooltip);
//                                 }}
//                                 onMouseLeave={(e) => {
//                                   e.currentTarget.style.transform = "scale(1)";
//                                   const tooltip =
//                                     document.getElementById("delete-tooltip");
//                                   if (tooltip) tooltip.remove();
//                                 }}
//                                 onClick={() =>
//                                   handleOpenModal("delete", vehicleMake)
//                                 }
//                               >
//                                 <Icon icon="mingcute:delete-2-line" />
//                               </button>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 {loading && (
//                   <div
//                     className="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center"
//                     style={{
//                       zIndex: 10,
//                       borderRadius: "10px",
//                       padding: "20px",
//                     }}
//                   >
//                     <LoadingComponent />
//                   </div>
//                 )}
//                 <PaginationControls
//                   pagination={{
//                     currentPage,
//                     perPage,
//                     total: totalEntries,
//                     totalPages,
//                   }}
//                   handlePageChange={handlePageChange}
//                 />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Main Modal */}
//       <div
//         className={`modal fade ${showModal ? "show d-block" : ""}`}
//         tabIndex="-1"
//         style={{
//           backgroundColor: showModal ? "rgba(0,0,0,0.5)" : "transparent",
//         }}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">
//                 {modalType === "add"
//                   ? "Add New Vehicle Make"
//                   : modalType === "edit"
//                   ? "Edit Vehicle Make"
//                   : "Delete Vehicle Make"}
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={handleCloseModal}
//               ></button>
//             </div>
//             <div className="modal-body">
//               {modalType === "delete" ? (
//                 <p>
//                   Are you sure you want to delete{" "}
//                   <strong>
//                     {selectedVehicleMake?.make_name || "this vehicle make"}
//                   </strong>
//                   ?
//                 </p>
//               ) : (
//                 <>
//                   <div className="mb-3">
//                     <label htmlFor="makeName" className="form-label">
//                       Vehicle Make Name
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       id="makeName"
//                       value={makeName}
//                       onChange={(e) => setMakeName(e.target.value)}
//                       placeholder="Enter vehicle make name"
//                     />
//                   </div>
//                   <div className="mb-3">
//                     <label htmlFor="makeImage" className="form-label">
//                       Vehicle Make Image
//                     </label>
//                     <input
//                       type="file"
//                       className="form-control"
//                       id="makeImage"
//                       accept="image/*"
//                       onChange={handleImageSelect}
//                       disabled={imageUploading}
//                     />
//                     {imageUploading && (
//                       <div className="mt-2">
//                         <div
//                           className="spinner-border spinner-border-sm"
//                           role="status"
//                         >
//                           <span className="visually-hidden">Uploading...</span>
//                         </div>
//                         <span className="ms-2">Uploading image...</span>
//                       </div>
//                     )}
//                     {makeImage && (
//                       <div className="mt-2">
//                         <img
//                           src={URL.createObjectURL(makeImage)}
//                           alt="Preview"
//                           className="image-preview"
//                           style={{ maxWidth: "100px", maxHeight: "100px" }}
//                           onClick={() =>
//                             handleOpenImageModal(URL.createObjectURL(makeImage))
//                           }
//                         />
//                       </div>
//                     )}
//                     {selectedVehicleMake?.make_image && !makeImage && (
//                       <div className="mt-2">
//                         <img
//                           src={selectedVehicleMake.make_image}
//                           alt={selectedVehicleMake.make_name}
//                           className="image-preview"
//                           style={{ maxWidth: "100px", maxHeight: "100px" }}
//                           onClick={() =>
//                             handleOpenImageModal(selectedVehicleMake.make_image)
//                           }
//                         />
//                       </div>
//                     )}
//                   </div>
//                 </>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 onClick={handleCloseModal}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className={`btn ${
//                   modalType === "delete" ? "btn-danger" : "btn-primary-600"
//                 }`}
//                 onClick={handleSubmit}
//                 disabled={saveLoading || imageUploading}
//               >
//                 {modalType === "add"
//                   ? saveLoading
//                     ? "Please wait..."
//                     : "Add Vehicle Make"
//                   : modalType === "edit"
//                   ? saveLoading
//                     ? "Please wait..."
//                     : "Update Vehicle Make"
//                   : saveLoading
//                   ? "Please wait..."
//                   : "Delete Vehicle Make"}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Crop Modal */}
//       <div
//         className={`modal fade ${showCropModal ? "show d-block" : ""}`}
//         tabIndex="-1"
//         style={{
//           backgroundColor: showCropModal ? "rgba(0,0,0,0.5)" : "transparent",
//         }}
//       >
//         <div className="modal-dialog modal-dialog-centered modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Crop Image</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={handleCloseCropModal}
//               ></button>
//             </div>
//             <div className="modal-body">
//               {imageToCrop && (
//                 <>
//                   <Cropper
//                     src={imageToCrop}
//                     style={{ height: 400, width: "100%" }}
//                     initialAspectRatio={1}
//                     aspectRatio={1}
//                     guides={true}
//                     viewMode={1}
//                     minCropBoxWidth={200}
//                     minCropBoxHeight={200}
//                     background={false}
//                     responsive={true}
//                     autoCropArea={1}
//                     checkOrientation={false}
//                     crop={handleCropMove}
//                     ref={cropperRef}
//                   />
//                   <p className="aspect-ratio-display">
//                     Current Aspect Ratio: {aspectRatio}
//                   </p>
//                 </>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 onClick={handleCloseCropModal}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="btn btn-primary-600"
//                 onClick={handleCrop}
//               >
//                 Crop & Upload
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Image Preview Modal */}
//       <div
//         className={`modal fade ${showImageModal ? "show d-block" : ""}`}
//         tabIndex="-1"
//         style={{
//           backgroundColor: showImageModal ? "rgba(0,0,0,0.8)" : "transparent",
//         }}
//       >
//         <div className="modal-dialog modal-dialog-centered modal-lg">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Image Preview</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 onClick={handleCloseImageModal}
//               ></button>
//             </div>
//             <div className="modal-body d-flex justify-content-center align-items-center">
//               {selectedImage && (
//                 <img
//                   src={selectedImage}
//                   alt="Vehicle Make"
//                   style={{
//                     maxWidth: "100%",
//                     maxHeight: "70vh",
//                     objectFit: "contain",
//                   }}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VehicleMakesLayer;

import { Icon } from "@iconify/react/dist/iconify.js";
import { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import LoadingComponent from "./ui/LoadingComponent";
import TableDataNoAvailable from "./ui/TableDataNoAvailable";
import PaginationControls from "./ui/PaginationControls";
import PerPageDropdown from "./ui/PerPageDropdown";
import { apiCall } from "../Apis/apiCall";
import { usePermissions } from "../context/PermissionContext";
import { handleApiResponse, handleCustomResponse } from "../utils/response";
import SortIcons from "./ui/SortIcons";
import ErrorAlert from "./ui/ErrorAlert";

const VehicleMakesLayer = () => {
  const [vehicleMakes, setVehicleMakes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalType, setModalType] = useState(""); // 'add', 'edit', or 'delete'
  const [showModal, setShowModal] = useState(false);
  const [vehicleMakeId, setVehicleMakeId] = useState(null);
  const [makeName, setMakeName] = useState("");
  const [makeImage, setMakeImage] = useState(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [imageUploading, setImageUploading] = useState(false);
  const [selectedVehicleMake, setSelectedVehicleMake] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [saveLoading, setSaveLoading] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    field: "make_name",
    direction: "asc",
  });
  const [expandedRows, setExpandedRows] = useState({});
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);
  const [aspectRatio, setAspectRatio] = useState("1:1");
  const [error, setError] = useState(null);
  const cropperRef = useRef(null);
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const debouncedSetSearch = useCallback(
    debounce((query) => setDebouncedSearchQuery(query), 500),
    []
  );

  useEffect(() => {
    debouncedSetSearch(searchQuery);
  }, [searchQuery, debouncedSetSearch]);

  const fetchVehicleMakes = async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        search: debouncedSearchQuery,
        sort_by: sortConfig.field,
        sort_order: sortConfig.direction,
        per_page: perPage,
        page: currentPage,
      };
      const response = await apiCall("get", "/get-all-vehicle-makes", params);
      setVehicleMakes(response.data.data.data);
      setTotalEntries(response.data.data.total);
      setTotalPages(
        response.data.data.last_page ||
          response.data.data.total_pages ||
          Math.ceil(response.data.data.total / perPage)
      );
      setCurrentPage(response.data.data.current_page);

      const handleRes = response.data;
      handleApiResponse(handleRes, "success", "GET");
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "GET");
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicleMakes();
  }, [debouncedSearchQuery, sortConfig, perPage, currentPage]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleSort = (field) => {
    if (field === "created_by") return; // Skip unavailable field
    setSortConfig((prev) => ({
      field,
      direction:
        prev.field === field && prev.direction === "asc" ? "desc" : "asc",
    }));
    setCurrentPage(1);
  };

  const handleOpenModal = (type, vehicleMake = null) => {
    setModalType(type);
    setShowModal(true);
    setVehicleMakeId(null);
    setMakeName("");
    setMakeImage(null);
    setUploadedImageUrl(null);
    setImageUploading(false);
    setSelectedVehicleMake(null);

    if (type === "edit" && vehicleMake) {
      setVehicleMakeId(vehicleMake.make_id);
      setMakeName(vehicleMake.make_name || "");
      setUploadedImageUrl(vehicleMake.make_image || null);
      setSelectedVehicleMake(vehicleMake);
    } else if (type === "delete" && vehicleMake) {
      setSelectedVehicleMake(vehicleMake);
      setVehicleMakeId(vehicleMake.make_id);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalType("");
    setVehicleMakeId(null);
    setMakeName("");
    setMakeImage(null);
    setUploadedImageUrl(null);
    setImageUploading(false);
    setSelectedVehicleMake(null);
  };

  const handleOpenImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        handleCustomResponse("error", "Image size should not exceed 5MB.");
        return;
      }
      if (!file.type.startsWith("image/")) {
        handleCustomResponse("error", "Please select a valid image file.");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setImageToCrop(reader.result);
        setShowCropModal(true);
        setAspectRatio("1:1");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCrop = async () => {
    if (cropperRef.current) {
      const canvas = cropperRef.current.cropper.getCroppedCanvas({
        width: 200,
        height: 200,
      });

      canvas.toBlob(
        async (blob) => {
          if (!blob) {
            handleCustomResponse("error", "Failed to crop image.");
            return;
          }
          const file = new File([blob], `vehicle-make-${Date.now()}.png`, {
            type: "image/png",
          });
          setMakeImage(file);
          setShowCropModal(false);
          await handleImageUpload(file);
        },
        "image/png",
        0.8
      );
    } else {
      handleCustomResponse("error", "Cropper not initialized.");
    }
  };

  const handleImageUpload = async (file) => {
    if (!file) {
      handleCustomResponse("error", "No image selected for upload.");
      return;
    }

    try {
      setImageUploading(true);
      const formData = new FormData();
      formData.append("vehicle_make", file);

      const response = await apiCall(
        "post",
        "/upload-image",
        formData,
        navigate,
        true
      );

      if (response?.data?.tiny_url) {
        setUploadedImageUrl(response.data.tiny_url);
        setMakeImage(file);
        handleCustomResponse("success", "Image uploaded successfully!");
      } else {
        handleCustomResponse("error", "Failed to upload image.");
        setMakeImage(null);
      }
    } catch (error) {
      handleCustomResponse("error", "Error uploading image.");
      setMakeImage(null);
    } finally {
      setImageUploading(false);
    }
  };

  const handleCloseCropModal = () => {
    setShowCropModal(false);
    setImageToCrop(null);
    setAspectRatio("1:1");
  };

  const handleCropMove = () => {
    if (cropperRef.current) {
      const cropBoxData = cropperRef.current.cropper.getCropBoxData();
      const width = cropBoxData.width;
      const height = cropBoxData.height;
      const ratio = width / height;
      setAspectRatio(`${(width / height).toFixed(2)}:1`);
    }
  };

  const handleAddVehicleMake = async () => {
    if (!makeName.trim()) {
      handleCustomResponse("error", "Vehicle Make Name is required.");
      return;
    }

    setSaveLoading(true);
    try {
      const formData = new FormData();
      formData.append("make_name", makeName);
      if (uploadedImageUrl) formData.append("make_image", uploadedImageUrl);

      const response = await apiCall(
        "post",
        "/add-vehicle-make",
        formData,
        navigate,
        true
      );
      const handleRes = response.data;
      handleApiResponse(handleRes, "success", "POST");
      fetchVehicleMakes();
      handleCloseModal();
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "POST");
    } finally {
      setSaveLoading(false);
    }
  };

  const handleUpdateVehicleMake = async () => {
    if (!makeName.trim()) {
      handleCustomResponse("error", "Vehicle Make Name is required.");
      return;
    }

    if (!vehicleMakeId || isNaN(vehicleMakeId)) {
      handleCustomResponse("error", "Invalid or missing Vehicle Make ID.");
      return;
    }

    setSaveLoading(true);
    try {
      const updateData = {
        make_name: makeName,
      };

      if (uploadedImageUrl) {
        updateData.make_image = uploadedImageUrl;
      }

      const res = await apiCall(
        "put",
        `/update-vehicle-make/${vehicleMakeId}`,
        updateData,
        navigate,
        false
      );
      const handleRes = res.data;
      handleApiResponse(handleRes, "success", "PUT");
      fetchVehicleMakes();
      handleCloseModal();
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "PUT");
    } finally {
      setSaveLoading(false);
    }
  };

  const handleDeleteVehicleMake = async () => {
    if (!vehicleMakeId || isNaN(vehicleMakeId)) {
      handleCustomResponse("error", "Invalid or missing Vehicle Make ID.");
      return;
    }

    setSaveLoading(true);
    try {
      const res = await apiCall(
        "delete",
        `/delete-vehicle-make/${vehicleMakeId}`,
        null,
        navigate
      );

      const handleRes = res.data;
      handleApiResponse(handleRes, "success", "DELETE");
      fetchVehicleMakes();
      handleCloseModal();
    } catch (error) {
      const handleErr = error.response?.data;
      handleApiResponse(handleErr, "Err", "DELETE");
    } finally {
      setSaveLoading(false);
    }
  };

  const handleSubmit = () => {
    if (modalType === "add") {
      handleAddVehicleMake();
    } else if (modalType === "edit") {
      handleUpdateVehicleMake();
    } else if (modalType === "delete") {
      handleDeleteVehicleMake();
    }
  };

  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleAddModel = (makeId) => {
    navigate(`/vehicle-models?makeId=${makeId}&addModel=true`);
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const toggleExpand = (makeId, field) => {
    setExpandedRows((prev) => ({
      ...prev,
      [`${makeId}_${field}`]: !prev[`${makeId}_${field}`],
    }));
  };

  const startEntry = totalEntries > 0 ? (currentPage - 1) * perPage + 1 : 0;
  const endEntry = Math.min(currentPage * perPage, totalEntries);
  if (error) {
    return <ErrorAlert />;
  }
  return (
    <div className="p-4 p-md-3 p-sm-2">
      <style>
        {`
          .table-responsive .table td, .table-responsive .table th {
            max-width: 200px;
            vertical-align: middle;
          }
          .show-more-btn {
            color: #E63C23;
            cursor: pointer;
            font-size: 12px;
            margin-left: 5px;
            background: none;
            border: none;
            padding: 0;
          }
          .show-more-btn:hover {
            text-decoration: underline;
          }
          .image-preview {
            cursor: pointer;
            transition: transform 0.2s;
          }
          .image-preview:hover {
            transform: scale(1.05);
          }
          @media (max-width: 576px) {
            .table-responsive .table td, .table-responsive .table th {
              max-width: 100px;
            }
            .show-more-btn {
              font-size: 10px;
            }
          }
          .cropper-container {
            max-height: 400px;
            max-width: 100%;
          }
          .aspect-ratio-display {
            font-size: 14px;
            color: #333;
            margin-top: 10px;
            text-align: center;
          }
        `}
      </style>
      <div className="p-4 p-md-3 p-sm-2">
        <div className="card shadow-sm">
          <div className="card p-3 p-sm-2 p-md-3">
            <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
              <div
                className="icon-field flex-grow-1"
                style={{ maxWidth: "400px" }}
              >
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search by vehicle make..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                <span className="icon">
                  <Icon icon="ion:search-outline" />
                </span>
              </div>
              <PerPageDropdown
                perPage={perPage}
                handlePerPageChange={(value) => {
                  setPerPage(value);
                  setCurrentPage(1);
                }}
              />
              <div className="ms-auto">
                {hasPermission("insert_vehicle_makes") && (
                  <button
                    className="btn btn-primary-600 btn-sm d-flex align-items-center"
                    onClick={() => handleOpenModal("add")}
                  >
                    <Icon icon="ri:add-line" className="me-1" /> Add Vehicle
                    Make
                  </button>
                )}
              </div>
            </div>

            {vehicleMakes.length === 0 && !loading ? (
              <TableDataNoAvailable message="No vehicle makes found." />
            ) : (
              <div className="position-relative">
                <div
                  className="table-responsive"
                  style={{
                    opacity: loading ? 0.4 : 1,
                    pointerEvents: loading ? "none" : "auto",
                  }}
                >
                  <table className="table bordered-table mb-0 table-hover">
                    <thead>
                      <tr
                        style={{ backgroundColor: "#475EAB", color: "white" }}
                      >
                        <th scope="col" className="p-2">
                          <span>S.No</span>
                        </th>
                        <th
                          scope="col"
                          className="p-2"
                          onClick={() => handleSort("make_name")}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <span>Vehicle Make</span>
                            <SortIcons
                              field="make_name"
                              sortConfig={sortConfig}
                            />
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="p-2"
                          onClick={() => handleSort("created_datetime")}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <span>Created Date</span>
                            <SortIcons
                              field="created_datetime"
                              sortConfig={sortConfig}
                            />
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="p-2"
                          onClick={() => handleSort("make_image")}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <span>Image</span>
                            <SortIcons
                              field="make_image"
                              sortConfig={sortConfig}
                            />
                          </div>
                        </th>
                        <th
                          scope="col"
                          className="p-2"
                          onClick={() => handleSort("is_active")}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="d-flex ">
                            <span>Status</span>
                            <SortIcons
                              field="is_active"
                              sortConfig={sortConfig}
                            />
                          </div>
                        </th>
                        <th scope="col" className="p-2">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {vehicleMakes.map((vehicleMake, index) => (
                        <tr key={vehicleMake.make_id || index}>
                          <td className="p-2">{startEntry + index}</td>
                          <td className="p-2">
                            <span className="">
                              {expandedRows[`${vehicleMake.make_id}_make_name`]
                                ? vehicleMake.make_name || "-"
                                : truncateText(vehicleMake.make_name || "-")}
                              {vehicleMake.make_name &&
                                vehicleMake.make_name.length > 50 && (
                                  <button
                                    className="show-more-btn"
                                    onClick={() =>
                                      toggleExpand(
                                        vehicleMake.make_id,
                                        "make_name"
                                      )
                                    }
                                  >
                                    {expandedRows[
                                      `${vehicleMake.make_id}_make_name`
                                    ]
                                      ? "Show Less"
                                      : "Show More"}
                                  </button>
                                )}
                            </span>
                          </td>
                          <td className="p-2">
                            {new Date(
                              vehicleMake.created_datetime
                            ).toLocaleString() || "-"}
                          </td>
                          <td className="p-2">
                            {vehicleMake.make_image ? (
                              <img
                                src={vehicleMake.make_image}
                                alt={vehicleMake.make_name}
                                className="image-preview"
                                style={{ maxWidth: "50px", maxHeight: "50px" }}
                                onClick={() =>
                                  handleOpenImageModal(vehicleMake.make_image)
                                }
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="p-2">
                            <span
                              className={`px-3 py-1 radius-4 fw-medium text-sm ${
                                vehicleMake.is_active
                                  ? "bg-success-focus text-success-600 border border-success-main"
                                  : "bg-danger-focus text-danger-600 border border-danger-main"
                              }`}
                            >
                              {vehicleMake.is_active ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td className="p-2">
                            {hasPermission("insert_vehicle_models") && (
                              <button
                                className="w-32-px h-32-px me-8 bg-warning-focus text-warning-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                style={{
                                  position: "relative",
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "scale(1.1)";
                                  const tooltip = document.createElement("div");
                                  tooltip.textContent = "Add Model";
                                  tooltip.style.cssText = `
        position: absolute;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);
        background-color: #333;
        color: white;
        padding: 5px 8px;
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        z-index: 1000;
        pointer-events: none;
      `;
                                  tooltip.id = "add-model-tooltip";
                                  e.currentTarget.appendChild(tooltip);
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                                  const tooltip =
                                    document.getElementById(
                                      "add-model-tooltip"
                                    );
                                  if (tooltip) tooltip.remove();
                                }}
                                onClick={() =>
                                  handleAddModel(vehicleMake.make_id)
                                }
                              >
                                <Icon icon="ri:car-line" />
                              </button>
                            )}
                            {hasPermission("update_vehicle_makes") && (
                              <button
                                className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                style={{
                                  position: "relative",
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "scale(1.1)";
                                  const tooltip = document.createElement("div");
                                  tooltip.textContent = "Edit";
                                  tooltip.style.cssText = `
                                    position: absolute;
                                    top: -35px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    background-color: #333;
                                    color: white;
                                    padding: 5px 8px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    white-space: nowrap;
                                    z-index: 1000;
                                    pointer-events: none;
                                  `;
                                  tooltip.id = "edit-tooltip";
                                  e.currentTarget.appendChild(tooltip);
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                                  const tooltip =
                                    document.getElementById("edit-tooltip");
                                  if (tooltip) tooltip.remove();
                                }}
                                onClick={() =>
                                  handleOpenModal("edit", vehicleMake)
                                }
                              >
                                <Icon icon="lucide:edit" />
                              </button>
                            )}
                            {hasPermission("delete_vehicle_makes") && (
                              <button
                                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                style={{
                                  position: "relative",
                                  transition: "all 0.3s ease",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform =
                                    "scale(1.1)";
                                  const tooltip = document.createElement("div");
                                  tooltip.textContent = "Delete";
                                  tooltip.style.cssText = `
                                    position: absolute;
                                    top: -35px;
                                    left: 50%;
                                    transform: translateX(-50%);
                                    background-color: #333;
                                    color: white;
                                    padding: 5px 8px;
                                    border-radius: 4px;
                                    font-size: 12px;
                                    white-space: nowrap;
                                    z-index: 1000;
                                    pointer-events: none;
                                  `;
                                  tooltip.id = "delete-tooltip";
                                  e.currentTarget.appendChild(tooltip);
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = "scale(1)";
                                  const tooltip =
                                    document.getElementById("delete-tooltip");
                                  if (tooltip) tooltip.remove();
                                }}
                                onClick={() =>
                                  handleOpenModal("delete", vehicleMake)
                                }
                              >
                                <Icon icon="mingcute:delete-2-line" />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {loading && (
                  <div
                    className="position-absolute top-50 start-50 translate-middle d-flex justify-content-center align-items-center"
                    style={{
                      zIndex: 10,
                      borderRadius: "10px",
                      padding: "20px",
                    }}
                  >
                    <LoadingComponent />
                  </div>
                )}
                <PaginationControls
                  pagination={{
                    currentPage,
                    perPage,
                    total: totalEntries,
                    totalPages,
                  }}
                  handlePageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Main Modal */}
      <div
        className={`modal fade ${showModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{
          backgroundColor: showModal ? "rgba(0,0,0,0.5)" : "transparent",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {modalType === "add"
                  ? "Add New Vehicle Make"
                  : modalType === "edit"
                  ? "Edit Vehicle Make"
                  : "Delete Vehicle Make"}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseModal}
              ></button>
            </div>
            <div className="modal-body">
              {modalType === "delete" ? (
                <p>
                  Are you sure you want to delete{" "}
                  <strong>
                    {selectedVehicleMake?.make_name || "this vehicle make"}
                  </strong>
                  ?
                </p>
              ) : (
                <>
                  <div className="mb-3">
                    <label htmlFor="makeName" className="form-label">
                      Vehicle Make Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="makeName"
                      value={makeName}
                      onChange={(e) => setMakeName(e.target.value)}
                      placeholder="Enter vehicle make name"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="makeImage" className="form-label">
                      Vehicle Make Image
                    </label>

                    {/* Hidden actual file input */}
                    <input
                      type="file"
                      className="form-control d-none"
                      id="makeImage"
                      accept="image/*"
                      onChange={handleImageSelect}
                      disabled={imageUploading}
                      ref={(input) => {
                        window.makeFileInput = input;
                      }}
                    />

                    {/* Custom styled "file input" */}
                    <div
                      className="form-control d-flex align-items-center justify-content-between"
                      style={{
                        cursor: imageUploading ? "not-allowed" : "pointer",
                        opacity: imageUploading ? 0.6 : 1,
                      }}
                      onClick={() =>
                        !imageUploading && window.makeFileInput?.click()
                      }
                    >
                      <span
                        className={`${
                          uploadedImageUrl || selectedVehicleMake?.make_image
                            ? "text-primary"
                            : "text-muted"
                        }`}
                      >
                        {makeImage
                          ? makeImage.name
                          : selectedVehicleMake?.make_image
                          ? selectedVehicleMake.make_image.split("/").pop()
                          : "No file chosen"}
                      </span>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        style={{ pointerEvents: "none" }}
                      >
                        Choose File
                      </button>
                    </div>

                    {imageUploading && (
                      <div className="mt-2">
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        >
                          <span className="visually-hidden">Uploading...</span>
                        </div>
                        <span className="ms-2">Uploading image...</span>
                      </div>
                    )}

                    {makeImage && (
                      <div className="mt-2">
                        <img
                          src={URL.createObjectURL(makeImage)}
                          alt="Preview"
                          className="image-preview"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                          onClick={() =>
                            handleOpenImageModal(URL.createObjectURL(makeImage))
                          }
                        />
                      </div>
                    )}

                    {selectedVehicleMake?.make_image && !makeImage && (
                      <div className="mt-2">
                        <img
                          src={selectedVehicleMake.make_image}
                          alt={selectedVehicleMake.make_name}
                          className="image-preview"
                          style={{ maxWidth: "100px", maxHeight: "100px" }}
                          onClick={() =>
                            handleOpenImageModal(selectedVehicleMake.make_image)
                          }
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${
                  modalType === "delete" ? "btn-danger" : "btn-primary-600"
                }`}
                onClick={handleSubmit}
                disabled={saveLoading || imageUploading}
              >
                {modalType === "add"
                  ? saveLoading
                    ? "Please wait..."
                    : "Add Vehicle Make"
                  : modalType === "edit"
                  ? saveLoading
                    ? "Please wait..."
                    : "Update Vehicle Make"
                  : saveLoading
                  ? "Please wait..."
                  : "Delete Vehicle Make"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Crop Modal */}
      <div
        className={`modal fade ${showCropModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{
          backgroundColor: showCropModal ? "rgba(0,0,0,0.5)" : "transparent",
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Crop Image</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseCropModal}
              ></button>
            </div>
            <div className="modal-body">
              {imageToCrop && (
                <>
                  <Cropper
                    src={imageToCrop}
                    style={{ height: 400, width: "100%" }}
                    initialAspectRatio={1}
                    aspectRatio={1}
                    guides={true}
                    viewMode={1}
                    minCropBoxWidth={200}
                    minCropBoxHeight={200}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false}
                    crop={handleCropMove}
                    ref={cropperRef}
                  />
                  <p className="aspect-ratio-display">
                    Current Aspect Ratio: {aspectRatio}
                  </p>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseCropModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary-600"
                onClick={handleCrop}
              >
                Crop & Upload
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Modal */}
      <div
        className={`modal fade ${showImageModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{
          backgroundColor: showImageModal ? "rgba(0,0,0,0.8)" : "transparent",
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Image Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseImageModal}
              ></button>
            </div>
            <div className="modal-body d-flex justify-content-center align-items-center">
              {selectedImage && (
                <img
                  src={selectedImage}
                  alt="Vehicle Make"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "70vh",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleMakesLayer;
